<button phx-button phxButtonRole="secondary" class="phx-filter-row-button-toggle" (click)="isFilterRowExpanded = !isFilterRowExpanded">
  {{ (isFilterRowExpanded ? "Hide Filters" : "Show Filters") | phxTranslate }}
</button>
<!-- TODO: replace this with phx-divider -->
<hr *ngIf="isFilterRowExpanded" class="phx-filter-row-divider" />
<div
  #filterRowNew
  *ngIf="!phxLoading"
  class="phx-filter-row-container"
  [class.phx-filter-row-expanded]="isFilterRowExpanded"
  (cdkObserveContent)="adjustFilterRowContent(true)"
>
  <div #mainFilters class="phx-filter-row-main" [class.phx-filter-row-expanded]="isFilterRowExpanded">
    <ng-container [ngTemplateOutlet]="filterContent"></ng-container>
  </div>
  <div #moreFilter>
    <phx-tile
      [phxDropdownFor]="dropdown"
      phxTrigger="click"
      [phxSelected]="selectedFiltersCountInDropdown > 0"
      phxDropdownClassName="phx-more-filter-dropdown-container"
      class="phx-more-filter"
      [phxClickable]="true"
      [phxBorder]="true"
      [phxBorderStates]="true"
      [(phxVisible)]="isDropdownOpen"
      phxSize="medium"
    >
      <span class="phx-more-filter-content">{{ "More" | phxTranslate }} <phx-badge [phxCount]="selectedFiltersCountInDropdown"></phx-badge></span>
      <i phx-icon [phxIcon]="ChevronDownIcon" phx-tile-suffix></i>
    </phx-tile>
    <phx-dropdown #dropdown>
      <div
        class="phx-more-filter-dropdown"
        #moreFilterDropdown
      ></div>
    </phx-dropdown>
  </div>
  <ng-container [ngTemplateOutlet]="resetButton"></ng-container>
  <div #rightFilters class="phx-filter-row-right-content">
    <ng-container [ngTemplateOutlet]="rightContent"></ng-container>
  </div>
</div>
<div class="phx-filter-row-main phx-filter-row-main-skeleton" [class.phx-filter-row-expanded]="isFilterRowExpanded" *ngIf="phxLoading">
  <phx-skeleton
    phxShape="rounded"
    [phxCount]="4"
    [phxDirection]="isFilterRowExpanded ? 'row' : 'column'"
    phxSpacing="12px"
    phxHeight="36px"
    [phxWidth]="isFilterRowExpanded ? '100%' : '120px'"
  ></phx-skeleton>
  <phx-skeleton
    phxShape="rounded"
    [phxCount]="1"
    [phxDirection]="isFilterRowExpanded ? 'row' : 'column'"
    class="phx-right-skeleton"
    [phxPosition]="'right'"
    phxSpacing="12px"
    phxHeight="36px"
    [phxWidth]="isFilterRowExpanded ? '100%' : '120px'"
  ></phx-skeleton>
</div>

<ng-template #filterContent>
  <ng-content></ng-content>
</ng-template>

<ng-template #resetButton>
  <ng-content select="[phx-reset-button]"></ng-content>
</ng-template>

<ng-template #rightContent>
  <ng-content select="[phx-filter-row-right-content]"></ng-content>
</ng-template>
